import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import { Box, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { track } from '@amplitude/analytics-browser'
import UserType from 'src/model/user-types'
import styles from './styles'

const AdvancedSettings = props => {
  const { classes, onSave, initialSettings } = props
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const hasScriptAccess =
    userControl !== 'Basic' && !UserType.isTrialEquivalent(userControl)
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )

  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings || {} : collectionSettings || {}

  const [headerScript, setHeaderScript] = useState('')
  const [bodyScript, setBodyScript] = useState('')

  // Initialize state from props when available
  useEffect(() => {
    if (landingPageData) {
      setHeaderScript(landingPageData.headerScripts || '')
      setBodyScript(landingPageData.bodyScripts || '')
    }
  }, [landingPageData])

  const handleScriptUpgradeRedirect = () => {
    if (hasScriptAccess) {
      return
    }

    track('limit_warning_upgrade', {
      from: 'landing_page_script_limit_upgrade',
    })
    window.location.href = '/pricing'
  }

  return (
    <div className={classes.container}>
      <div className={classes.scriptSection}>
        <Typography
          fontSize="16px"
          fontWeight={400}
          fontFamily="Inter"
          className={classes.header}
        >
          Advanced settings
        </Typography>
        <div>
          <Typography fontSize="14px" fontWeight={400} fontFamily="Inter">
            Header and Body Scripts
          </Typography>
          <Typography fontSize="12px" fontWeight={400} color="#919EAB">
            Add custom CSS & JS codes, like Google Analytics tracking code,
            Facebook Pixel, etc.
          </Typography>
        </div>

        <Box>
          <div className={classes.badgeHeader}>
            <Typography fontSize={'14px'} fontWeight={400}>
              Header Script
            </Typography>
            {!hasScriptAccess && (
              <div className={classes.badge}>
                <Typography
                  fontSize={'11px'}
                  fontWeight={500}
                  style={{ color: '#015FFB' }}
                >
                  Plus
                </Typography>
              </div>
            )}
          </div>
          <div onClick={handleScriptUpgradeRedirect}>
            <CoreTextField
              multiline
              rows={5}
              fullWidth
              placeholder="The codes you are going to write to this field will be added before </head> tag. You can add custom CSS or JS codes to this field."
              value={headerScript}
              marginTop={false}
              onChange={e => {
                const newValue = e.target.value
                setHeaderScript(newValue)
                if (initialSettings) {
                  onSave({
                    ...initialSettings,
                    headerScript: newValue,
                  })
                }
              }}
              disabled={!hasScriptAccess}
            />
          </div>
        </Box>

        <Box>
          <div className={classes.badgeHeader}>
            <Typography fontSize={'14px'} fontWeight={400}>
              Body Script
            </Typography>
            {!hasScriptAccess && (
              <div className={classes.badge}>
                <Typography
                  fontSize={'11px'}
                  fontWeight={500}
                  style={{ color: '#015FFB' }}
                >
                  Plus
                </Typography>
              </div>
            )}
          </div>
          <div onClick={handleScriptUpgradeRedirect}>
            <CoreTextField
              multiline
              rows={5}
              fullWidth
              marginTop={false}
              placeholder="The codes you are going to write to this field will be added before </body> tag."
              variant="outlined"
              value={bodyScript}
              onChange={e => {
                const newValue = e.target.value
                setBodyScript(newValue)
                if (initialSettings) {
                  onSave({
                    ...initialSettings,
                    bodyScript: newValue,
                  })
                }
              }}
              disabled={!hasScriptAccess}
            />
          </div>
        </Box>
      </div>
    </div>
  )
}
export default withStyles(styles)(AdvancedSettings)
